import React from "react";
import styled, { css } from "styled-components";
import LanguageOption from "../atoms/LanguageOption";
import { availableLanguages } from "../../i18n";
const StyledLanguageSelector = styled.div `
  position: absolute;
  top: 45px;
  right: 0;
  background-color: white;
  box-shadow: 0 10px 10px rgba(26, 26, 33, 0.11);
  padding: 15px;
  border-radius: 6px;
  display: ${props => (props.isExpanded ? "block" : "none")};
  width: 100%;
  min-width: 200px;
  z-index: 1;
  
  ${props => props.isReversed && css `
    bottom: 45px;
    top: auto;
  `};

  @media only screen and (min-width: 768px) {
    left: 0;
    right: auto;
    
    ${props => props.isReversed && css `
      top: 45px;
      right: 0;
      bottom: auto;
      left: auto;
    `};
  }
`;
const LanguageSelector = ({ isExpanded, isReversed }) => {
    return (React.createElement(StyledLanguageSelector, { isExpanded: isExpanded, isReversed: isReversed }, Object.keys(availableLanguages).map(key => (React.createElement(LanguageOption, { key: key, name: "language", image: availableLanguages[key].image, label: availableLanguages[key].label, value: key, inline: true })))));
};
export default LanguageSelector;
